export enum Namespace {
    Enrollment = 'enrollment',
    StatusDashboard = 'status_dashboard',
    AdminDashboard = 'admin_dashboard',
}

export enum Actor {
    Homeowner = 'homeowner',
    Contractor = 'contractor',
}

export enum Action {
    FillField = 'fill_field',
    SelectOption = 'select_option',
    ToggleOption = 'toggle_option',
    ClickButton = 'click_button',
    Navigate = 'navigate',
    ClickRecommendTechniques = 'click_recommend_techniques',
    ClickAllowPushNotifications = 'click_allow_push_notifications',
    StartSubmission = 'start_submission',
    ContinueSubmission = 'continue_submission',
    FinaliseSubmission = 'finalise_submission',
    IneligibleBecauseUnqualified = 'ineligible_because_unqualified',
    RedirectToSetle = 'redirect_to_setle',
    RedirectFromSetle = 'redirect_from_setle',
    AdviseTechniques = 'advise_techniques',
    OpenDashboard = 'open_dashboard',
    PageView = 'page_view',
    CallContractor = 'call_contractor',
    VisitContractorWebsite = 'visit_contractor_website',
    ClickViewQuote = 'click_view_quote',
    ClickAcceptQuote = 'click_accept_quote',
    ClickRejectQuote = 'click_reject_quote',
    ClickEditPersonalDetails = 'click_edit_personal_details',
    ClickGoToRequest = 'click_go_to_request',
    ClickCompleteTask = 'click_complete_task',
    OpenTaskDetail = 'open_task_detail',
}

export type Context = Record<string, any>

export type EventName = string

export function buildEventName(namespace: Namespace, actor: Actor, action: Action): EventName {
    return `${namespace}_${actor}_${action}`
}

export type Page = {
    pageName: string
    workflowType?: string | null
    pageUrl: string
    userId: string
}
